import { SpeedDialIcon, SpeedDialAction, SpeedDial } from "../../core";
import {
  SubjectIcon,
  OndemandVideoIcon,
  FormatQuoteIcon,
  MenuBookIcon,
  LiveHelpIcon,
  ImageIcon,
  ListIcon,
  TableIcon,
  HeaderIcon,
} from "../../core/Icons";

export const NewLessonStepButton = ({ handleSelect, disabled = false }) => {

  return (
    <SpeedDial
      ariaLabel="SpeedDial openIcon"
      icon={<SpeedDialIcon />}
      open={!disabled}
      hidden={true}
      direction={`left`}
      style={{ marginTop: 10, padding: 0, opacity: disabled ? 0.45 : 1 }}

    >
      <SpeedDialAction
        key={0}
        icon={<SubjectIcon />}
        tooltipTitle={`Texto`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("Text")}
        TooltipClasses={{ marginBottom: 20 }}
        FabProps={{ disabled }}
      />
      <SpeedDialAction
        key={1}
        icon={<OndemandVideoIcon />}
        tooltipTitle={`Vídeo`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("Video")}
        FabProps={{ disabled }}
      />
      <SpeedDialAction
        key={2}
        icon={<FormatQuoteIcon />}
        tooltipTitle={`Aspas`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("Quotation")}
        FabProps={{ disabled }}
      />
      <SpeedDialAction
        key={3}
        icon={<MenuBookIcon />}
        tooltipTitle={`Citação Bíblica`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("Verse")}
        FabProps={{ disabled }}
      />
      <SpeedDialAction
        key={4}
        icon={<ImageIcon />}
        tooltipTitle={`Imagem`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("Image")}
        FabProps={{ disabled }}
      />
      <SpeedDialAction
        key={5}
        icon={<LiveHelpIcon />}
        tooltipTitle={`Pergunta`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("Question")}
        FabProps={{ disabled }}
      />
      <SpeedDialAction
        key={6}
        icon={<HeaderIcon />}
        tooltipTitle={`Header`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("Header")}
        FabProps={{ disabled }}
      />
      <SpeedDialAction
        key={7}
        icon={<ListIcon />}
        tooltipTitle={`Lista`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("List")}
        FabProps={{ disabled }}
      />
      <SpeedDialAction
        key={8}
        icon={<TableIcon />}
        tooltipTitle={`Tabela`}
        tooltipPlacement="top-start"
        onClick={() => !disabled && handleSelect("Table")}
        FabProps={{ disabled }}
      />
    </SpeedDial>
  );
};
